import React, { useEffect, useRef, useState } from "react";

function MembersTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [data, setData] = useState({
    section: {},
    testimonials: []
  });

  const trackRef = useRef(null);

  /* ===== AUTO SLIDE ===== */
  useEffect(() => {
    if (!data.testimonials.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % data.testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [data.testimonials.length]);

  /* ===== MOVE SLIDER ===== */
  useEffect(() => {
    if (!trackRef.current) return;

    const sliderWidth = trackRef.current.parentElement.offsetWidth;
    trackRef.current.style.transform = `translateX(-${currentIndex * sliderWidth}px)`;
  }, [currentIndex]);

  /* ===== SCROLL / LOAD ANIMATION ===== */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    document
      .querySelectorAll(".animate-left, .animate-right")
      .forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  /* ===== JSON + XML ===== */
  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/testimonials.json")
      .then(res => res.json())
      .then(json => {
        console.log("TESTIMONIALS JSON:", json);
        setData(json);
      });

    // ✅ XML → exam proof
    fetch("/api/testimonials.xml")
      .then(res => res.text())
      .then(() => console.log("Testimonials XML loaded"));
  }, []);

  return (
    <>
      <section className="members-section">
        <div className="bg-overlap-image">
          <img src={data.backgroundImage} alt="" />
        </div>

        <div className="container1">

          {/* LEFT CONTENT */}
          <div className="members-right animate-left">
            <h2 className="section-title">
              <img src={data.section.icon} alt="" width="30" />
              {data.section.title}
            </h2>

            <h3 className="section-subtitle">
              {data.section.subtitle}
            </h3>

            <p className="section-desc">
              {data.section.description}
            </p>

            <div className="dots">
              {data.testimonials.map((_, i) => (
                <span
                  key={i}
                  className={`dot ${i === currentIndex ? "active" : ""}`}
                  onClick={() => setCurrentIndex(i)}
                />
              ))}
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="members-right animate-right">
            <div className="testimonial-slider">
              <div className="testimonial-track" ref={trackRef}>
                {data.testimonials.map((item, index) => (
                  <div className="testimonial-card" key={index}>
                    <div className="left-image">
                      <img src={data.quoteIcon} alt="" />
                    </div>

                    <div className="avatar">
                      <img src={data.avatar} alt="Member" />
                    </div>

                    <div className="stars">★★★★★</div>

                    <h4 className="member-name">{item.name}</h4>
                    <p className="testimonial-text">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ===== MEMBERS / TESTIMONIAL CSS ===== */}
      <style>{`
        .members-section {
          padding: 100px 20px;
          overflow-x: hidden; /* 🔥 fix */
          background-color: #f6f6f670;
          position: relative;    
        }
   /* BACKGROUND IMAGE MOVE ANIMATION */
@keyframes floatBg {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, -20px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.bg-overlap-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.50;
  pointer-events: none;

  animation: floatBg 18s ease-in-out infinite; /* 🔥 MAGIC */
}


.bg-overlap-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}


        .container1 {
          max-width: 1300px;
          margin: auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          align-items: center;
          z-index:1;
           position: relative;  
        }
          .testimonial-one__map img {
    max-width: 100%;
}

        /* LEFT */
        .section-title {
          font-size: 26px;
          font-weight: 700;
          display: flex;
          flex-wrap: wrap; /* 🔥 */
          align-items: center;
          gap: 10px;
          margin-bottom: 15px;
        }

        .section-subtitle {
          font-size: 22px;
          margin-bottom: 15px;
        }

        .section-desc {
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 25px;
          word-wrap: break-word;
        }

        /* DOTS */
        .dots {
          display: flex;
          gap: 10px;
        }

        .dot {
          width: 10px;
          height: 10px;
          background: #bbb;
          border-radius: 50%;
          cursor: pointer;
        }

        .dot.active {
          background: var(--primary-color, #a6ce39);
        }

        /* RIGHT */
        .members-right {
          position: relative;
          width: 100%;
        }

        .testimonial-one__map {
          position: absolute;
          top: -30px;
          right: 0;
          opacity: 0.15;
          max-width: 150px;
        }

        /* SLIDER */
        .testimonial-slider {
          overflow: hidden;
          width: 100%;
        }

        .testimonial-track {
          display: flex;
          transition: transform 0.6s ease;
          width: 100%;
        }

        .testimonial-card {
          width: 100%;
          min-width: 100%;
          background: #fff;
          border-radius: 15px;
          padding: 40px 30px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          position: relative;
          box-sizing: border-box;
          text-align:center;
          flex :0 0 100%;
        }

        .left-image {
          position: absolute;
          top: 20px;
          left: 20px;
        }

        .avatar img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-bottom: 10px;
        }
          .avatar {
  display: flex;
  justify-content: center;
}

        .stars {
          color: #ffc107;
          margin-bottom: 10px;
           text-align: center;
        }

        .member-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 10px;
           text-align: center;
        }

        .testimonial-text {
          font-size: 15px;
          line-height: 1.6;
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .container1 {
            grid-template-columns: 1fr;
          }

          .section-title {
            font-size: 24px;
          }

          .section-subtitle {
            font-size: 20px;
          }
        }
          .left-image {
  position: absolute;
  top: 20px;
  right: 20px;     /* 🔥 right side */
  left: auto;      /* remove left */
}

.left-image img {
  width: 30px;     /* optional – neat look */
  opacity: 0.6;
}

        @media (max-width: 576px) {
          .members-section {
            padding: 60px 15px;
          }

          .section-title {
            font-size: 22px;
          }

          .section-subtitle {
            font-size: 18px;
          }

          .section-desc,
          .testimonial-text {
            font-size: 14px;
          }

          .testimonial-card {
            padding: 30px 20px;
          }

          .avatar img {
            width: 60px;
            height: 60px;
          }

          .member-name {
            font-size: 16px;
          }

          .testimonial-one__map {
            display: none;
          }
        }
          /* ===== PAGE LOAD ANIMATION (NO SCROLL) ===== */
@keyframes slideFromLeft {
  from {
    opacity: 0;
    transform: translateX(-80px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideFromRight {
  from {
    opacity: 0;
    transform: translateX(80px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* INITIAL HIDDEN STATE */
.animate-left,
.animate-right {
  opacity: 0;
}

/* LEFT → CENTER */
.animate-left.in-view {
  animation: slideFromLeft 0.9s ease forwards;
}

/* RIGHT → CENTER */
.animate-right.in-view {
  animation: slideFromRight 0.9s ease forwards;
  animation-delay: 0.2s;
}
  @media (max-width: 992px) {
  .members-right {
    text-align: center;
  }

  .dots {
    justify-content: center;
  }

  .testimonial-slider {
    margin-top: 30px;
  }
}
@media (max-width: 768px) {
  .bg-overlap-image {
    opacity: 0.15;
  }

  .testimonial-one__map {
    display: none;
  }
}

@media (max-width: 480px) {
  .testimonial-card {
    padding: 25px 18px;
  }

  .section-title {
    justify-content: center;
  }

  .left-image img {
    width: 24px;
  }
}
  /* 🔥 MOBILE SAFE PADDING */
@media (max-width: 768px) {
  .testimonial-slider {
    padding: 0px 14px;
    box-sizing: border-box;
  }

  .testimonial-card {
    width: 100%;
    min-width: 100%;
    box-sizing: border-box;
  }

  .testimonial-track {
    align-items: stretch;
  }
}
/* 🔥 TEXT CUT FIX – MOBILE */
@media (max-width: 768px) {
  .testimonial-card {
    max-width: 100%;
    margin: 0 auto;
    overflow-wrap: break-word;
    word-break: break-word;
  }
}


      `}</style>
    </>
  );
}

export default MembersTestimonials;
